module.exports = __webpack_public_path__ + "img/TS.ffd48c1e.png";